/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Masks_ValueInputs */

const en_landing_why_masks_value = /** @type {(inputs: Landing_Why_Masks_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint to edit`)
};

const zh_landing_why_masks_value = /** @type {(inputs: Landing_Why_Masks_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`涂抹即编辑`)
};

/**
* | output |
* | --- |
* | "Paint to edit" |
*
* @param {Landing_Why_Masks_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_masks_value = /** @type {((inputs?: Landing_Why_Masks_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Masks_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_masks_value(inputs)
	return zh_landing_why_masks_value(inputs)
});
export { landing_why_masks_value as "landing.why.masks_value" }